(function () {
  function getSnizeContainer() {
    return document.querySelector(
      '#snize-instant-search-results, .snize-ac-results'
    );
  }

  function allowScrollInsideSnize() {
    if (!window.bodyScrollLock) return;

    var el = getSnizeContainer();
    if (!el) return;

    try {
      window.bodyScrollLock.disableBodyScroll(el, {
        allowTouchMove: function (target) {
          return target.closest('#snize-instant-search-results, .snize-ac-results');
        }
      });
    } catch (e) {}
  }

  function clearLocksIfClosed() {
    if (!window.bodyScrollLock) return;
    if (!getSnizeContainer()) {
      try {
        window.bodyScrollLock.clearAllBodyScrollLocks();
      } catch (e) {}
    }
  }

  // Când Searchanise injectează rezultate
  const observer = new MutationObserver(function () {
    allowScrollInsideSnize();
    clearLocksIfClosed();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  // Backup pe click / tastare
  document.addEventListener('click', function () {
    setTimeout(allowScrollInsideSnize, 50);
  }, true);

  document.addEventListener('keyup', function () {
    setTimeout(allowScrollInsideSnize, 50);
  }, true);
})();
